import { ChangeEvent } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { DropdownWithLabel } from '@blueprint/dropdown';
import { MultiColumnDropdownWithLabel } from '@blueprint/multicolumn-dropdown';
import {
    updateFilter,
    bedsMinSelector,
    bedsMaxSelector
} from '@zoopla/redux-reducer-filters';
import {
    SelectBedsMinOptions,
    SelectBedsMaxOptions
} from 'search/common/SelectBedsOptions';
import { DropdownContainer } from 'search/common/DropdownContainer';
import { useSelectBedsTitle } from 'search/hooks/useSelectBedsTitle';

export const SelectBeds = () => {
    const reduxDispatch = useDispatch();
    const { selectedValue: bedsMinSelectedValue, options: bedsMinOptions } =
        useSelector(bedsMinSelector);
    const { selectedValue: bedsMaxSelectedValue, options: bedsMaxOptions } =
        useSelector(bedsMaxSelector);

    const bedsMinInt = parseInt(bedsMinSelectedValue, 10);

    const bedsMaxInt = parseInt(bedsMaxSelectedValue, 10);

    const dropdownTitle = useSelectBedsTitle();

    const onMaxBedsChange = (evt: ChangeEvent<HTMLSelectElement>) => {
        const {
            currentTarget: { value }
        } = evt;

        reduxDispatch(updateFilter('maxBedrooms', value));
    };

    const onMinBedsChange = (evt: ChangeEvent<HTMLSelectElement>) => {
        const {
            currentTarget: { value }
        } = evt;

        reduxDispatch(updateFilter('minBedrooms', value));
    };

    const bedroomsLabel = 'Bedrooms';
    const minBedsLabelText = 'Minimum beds';
    const maxBedsLabelText = 'Maximum beds';
    const bedroomsOptionsLabel = 'Any beds';

    return (
        <MultiColumnDropdownWithLabel
            id="AnyBeds_testId"
            title={dropdownTitle}
            testId="AnyBeds_testId"
            label={bedroomsLabel}
        >
            <DropdownContainer>
                <DropdownWithLabel
                    id="beds_min"
                    onChange={onMinBedsChange}
                    value={bedsMinSelectedValue}
                    name="beds_min"
                    hasBorderRadius
                    aria-label="Min Beds"
                    data-testid="min_beds_testid"
                    label={minBedsLabelText}
                >
                    {bedsMinOptions ? (
                        <SelectBedsMinOptions
                            bedsOtherInt={bedsMaxInt}
                            options={bedsMinOptions}
                            keyPrefix="quicksearch-min-beds"
                        />
                    ) : (
                        <option>{bedroomsOptionsLabel}</option>
                    )}
                </DropdownWithLabel>
            </DropdownContainer>
            <DropdownContainer>
                <DropdownWithLabel
                    id="beds_max"
                    onChange={onMaxBedsChange}
                    value={bedsMaxSelectedValue}
                    hasBorderRadius
                    name="beds_max"
                    aria-label="Maximum Beds"
                    data-testid="max_beds_testid"
                    label={maxBedsLabelText}
                >
                    {bedsMaxOptions ? (
                        <SelectBedsMaxOptions
                            bedsOtherInt={bedsMinInt}
                            options={bedsMaxOptions}
                            keyPrefix="quicksearch-max-beds"
                        />
                    ) : (
                        <option>{bedroomsOptionsLabel}</option>
                    )}
                </DropdownWithLabel>
            </DropdownContainer>
        </MultiColumnDropdownWithLabel>
    );
};
